import { BpCard } from '../BpCard/BpCard';
import { Select, SelectOptionType } from '@bp/ui-components';
import { SingleValue } from 'react-select';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useCreateSelectOptions } from '../../hooks/useCreateSelectOptions';
import { FragmentType, getFragmentData, graphql } from 'client/gql';

const TeachingUnitSelectFieldsDocument = graphql(`
  fragment TeachingUnitSelectFields on Query {
    teachingUnits(where: { group: { uuid: $courseUuid } }) {
      uuid
      __typename
      title
    }
  }
`);

type TeachingUnitSelectProps = {
  teachingUnitUuid: string;
  error?: string;
  isModal?: boolean;
  onChange: (teachingUnitUuid: string) => void;
  className?: string | undefined;
  query: FragmentType<typeof TeachingUnitSelectFieldsDocument> | undefined;
};

export const TeachingUnitSelect: FC<TeachingUnitSelectProps> = ({
  teachingUnitUuid,
  error,
  isModal,
  onChange,
  className,
  query,
}) => {
  const { t } = useTranslation();
  const fragment = getFragmentData(TeachingUnitSelectFieldsDocument, query);

  const opts = useCreateSelectOptions(fragment?.teachingUnits, 'uuid', 'title');

  return (
    <BpCard className={className} isEmbedded={isModal} header={{ headline: t('teachingUnits.titleSingular') }}>
      <Select
        className='mb-2'
        dense
        required={true}
        placeholder={t('common.chooseType', {
          type: t('teachingUnits.titleSingular'),
        })}
        name='teachingUnitSelect'
        disabled={false}
        defaultValue={opts.find((v) => v.value === teachingUnitUuid)}
        options={opts}
        onChange={(value) => {
          const singleValue = value as SingleValue<SelectOptionType>;
          onChange(singleValue?.value as string);
        }}
        error={error}
        menuPosition='fixed'
      />
    </BpCard>
  );
};
